
import * as React from 'react';
import { BaseComponent, BaseComponentState, BaseComponentProps } from '../base/BaseComponent';
import { isNull, getAjaxhelper } from '../utils/index';
import { SecurityData, CMS } from '../shared/index';
import { requestToken } from '../utils/request-token';
export interface ContactFormReviewrops extends BaseComponentProps {
    lang: string;
    from: string;
    userLogin: SecurityData.ApplicationUser;
    userId: number | any;
}
export interface ContactFormReviewState extends BaseComponentState {
    postData: CMS.Review | any;
    token?: string;
}
export class ContactFormReview extends BaseComponent<ContactFormReviewrops, ContactFormReviewState> {
    constructor(props: ContactFormReviewrops) {
        super(props);
        let custId: any = isNull(props.userLogin) ? null : props.userLogin.id;
        let email: any = isNull(props.userLogin) ? null : props.userLogin.email;
        let name: any = isNull(props.userLogin) ? null : props.userLogin.realName;
        this.state = {
            postData: {
                custId: custId,
                email: email,
                name: name,
                page: props.from,
                status: 'NEW',
                url: window.location.href,
                subject: '',
                message: '',
            }
        };
    }

    getToken: () => any = () => {
        requestToken().then(d => {
            this.setState({ token: d }, this.initialState);
        }).catch(exc => {
            console.log(exc);
        });
    }

    initialState: () => any = () => {
        let custId = isNull(this.props.userLogin) ? null : this.props.userLogin.id;
        let email = isNull(this.props.userLogin) ? null : this.props.userLogin.email;
        let name = isNull(this.props.userLogin) ? null : this.props.userLogin.realName;
        this.setState({
            postData: {
                custId: custId,
                email: email,
                name: name,
                page: this.props.from,
                status: 'NEW',
                url: window.location.href,
                subject: '',
                message: '',
            }
        });
    }

    componentWillMount() {
        this.getToken();
    }

    componentDidUpdate(prevProps: ContactFormReviewrops, prevState: ContactFormReviewState) {
        if (prevProps.from !== this.props.from || prevProps.userId !== this.props.userId) {
            this.getToken();
        }
    }

    submitForm: (evt: any) => any = (evt: any) => {
        evt.preventDefault();
        getAjaxhelper().put(`/dynamics/commons/direct-data/Review/add`, { data: this.state.postData, token: this.state.token }).then(
            d => {
                console.log(d);
            }
        ).catch(
            exc => {
                console.log(exc);
            }
        );
    }
    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let custName = (
            <div className="row">
                <div className="form-group">
                    <div className="col-md-6">
                        <label> Your name <span className="symbol required" /> </label>
                        <input
                            onChange={evt => {
                                let val: string = evt.target.value;
                                this.setStateHelper(st => {
                                    st.postData.name = val;
                                });
                            }}
                            type="text"
                            className="form-control"
                            required={true}
                        />
                    </div>
                    <div className="col-md-6">
                        <label> Your email address <span className="symbol required" /> </label>
                        <input
                            onChange={evt => {
                                let val: string = evt.target.value;
                                this.setStateHelper(st => {
                                    st.postData.email = val;
                                });
                            }}
                            required={true}
                            type="email"
                            value={this.state.postData.email}
                            className="form-control"
                        />
                    </div>
                </div>
            </div>
        );

        if (!isNull(this.props.userLogin)) {
            let imgUrl = isNull(this.props.userLogin.image_url) ? '/assets/images/user-icon.png' : this.props.userLogin.image_url;
            custName = (
                <div className="row" style={{ marginBottom: 15 }}>
                    <img src={imgUrl} style={{ width: 50, height: 50, marginRight: 15, float: 'left', borderRadius: '50%' }} />
                    <span style={{ display: 'block', fontSize: '1.2em' }}>{this.props.userLogin.realName}</span>
                    <span>{this.props.userLogin.email}</span>
                </div>
            );
        }
        // console.log("[ContactFormReview] State", this.state);
        // console.log("[ContactFormReview] Props", this.props);
        return (
            <form id="contactForm" onSubmit={this.submitForm}>
                {custName}
                <div className="row">
                    <div className="form-group">
                        <div className="col-md-12">
                            <label> Subject </label>
                            <input
                                onChange={evt => {
                                    console.log(evt.target.value);
                                    let val: string = evt.target.value;
                                    this.setStateHelper(st => {
                                        st.postData.subject = val;
                                    });
                                }}
                                required={true}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group">
                        <div className="col-md-12">
                            <label> Message <span className="symbol required" /> </label>
                            <textarea
                                value={this.state.postData.message}
                                onChange={evt => {
                                    let val: string = evt.target.value;
                                    this.setStateHelper(st => {
                                        st.postData.message = val;
                                    });
                                }}
                                required={true}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <button data-caption-delay="900" data-caption-class="fadeIn" className="btn btn-primary margin-top-15 opacity-0 btn-wide btn-scroll btn-scroll-top fa-arrow-right animated fadeIn" type="submit">
                            <span>Send Message</span>
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/core/ContactFormReview.tsx